import { store } from './store.js';
export function CartIcon(props){
	return{
		...props,
		get count(){
			return store.cart?.count ?? 0;
		},		
	}
}